import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { renderRoutes } from 'react-router-config';
import Header from './components/header';
import { REQUEST } from './actions/action_types';
import { GoogleAdSense, YahooFlurry } from './components/Tracker';

const Container = ({ route }) => {
  const location = useLocation();

  // SSR 資源檢查
  const isLocationCity = location.pathname.includes('/cities/');
  const isLocationCityMore =
    location.pathname.includes('/cities/') &&
    location.pathname.includes('/more');
  const isLocationProductLanding =
    location.pathname.includes('/products/') &&
    !location.pathname.includes('/pay/');
  const isSimWifiLanding = location.pathname.includes('/wifi-sim-card');
  const isCarRental = location.pathname.includes('/car-rental');

  const isLocationSSR =
    isLocationCity ||
    isLocationCityMore ||
    isLocationProductLanding ||
    isSimWifiLanding ||
    isCarRental;
  // 顯示或隱藏 SSR 進入點
  const contentSSR = document.getElementById('content-ssr');
  if (contentSSR) contentSSR.style.display = isLocationSSR ? 'block' : 'none';

  const { initRequestStatus } = useSelector(state => state.requestState);

  const isInitSuccess = initRequestStatus.state === REQUEST.SUCCESS;
  return (
    <div className="app-container">
      {isInitSuccess ? <Header /> : null}
      {renderRoutes(route.routes)}
      <GoogleAdSense />
      <YahooFlurry />
    </div>
  );
};

Container.defaultProps = {
  route: null
};

Container.propTypes = {
  route: PropTypes.object
};

export default Container;
